import ODAS from '@/utils/api/odas';

/**
 *
 *  */
const Referral = {
  loadReferrals: ({ client_id, locale }) => {
    return ODAS.get('api/agency_clients/' + client_id + '/referrals', { locale });
  },
  loadReferral: (referral_id) => {
    return ODAS.get('api/referrals/' + referral_id);
  },
  referralNotification: (referral_id, notificationInfo) => {
    return ODAS.post('/api/referrals/' + referral_id + '/notifications', notificationInfo);
  },
  loadAgencyRecipientInformation: () => {
    return ODAS.get('/api/agency_recipient_information');
  },
  createReferral: (referralHash, accessEvents) => {
    return ODAS.post('/api/referrals', { referral: referralHash, access_events: accessEvents });
  },
  removeAgencyRecipientInformation: (id) => {
    return ODAS.delete('/api/agency_recipient_information/' + id);
  }
};

export default Referral;
